import { render, staticRenderFns } from "./PartialOffer.vue?vue&type=template&id=7871efb0&scoped=true&lang=html"
import script from "./PartialOffer.vue?vue&type=script&lang=js"
export * from "./PartialOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7871efb0",
  null
  
)

export default component.exports